import { Box, Typography } from '@mui/material'
import React from 'react'
import { useSize } from '../../../hooks/useSize'
import styles from '../common.module.scss'

const DEIPolicy: React.FC = () => {
  const { matchTabletSize } = useSize()

  return (
    <>
      <Box maxWidth="md" className={`${styles.header} ${matchTabletSize ? styles.header__sp : styles.header__pc}`}>
        <Typography lineHeight={0.9} fontSize={matchTabletSize ? '26px' : '43px'} fontWeight="bold">
          DE&Iポリシー
        </Typography>
        <Typography fontSize={matchTabletSize ? '12px' : '20px'}>DE&I policy</Typography>
      </Box>
      <Box maxWidth="md" m="auto">
        <article className={matchTabletSize ? styles.container__sp : styles.container__pc}>
          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              １．当社がDE&Iを大切にする背景
            </Typography>
            <Typography variant="body1">
              当社は、Diversity, Equity, and
              Inclusion(以下、DE&I)が持続可能な社会の実現に重要な役割を果たし、企業の成長に不可欠であるとの認識のもと、ベンチャーコミュニティの一翼の担い手として、DE&Iを大切にしていきます。
            </Typography>
          </Box>

          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              ２．DE&Iの実現に向けて当社が目指すこと
            </Typography>
            <>
              <Typography variant="body1">
                当社は、DE&Iの実現に向けて、以下の事項の推進を目指していきます。 係法令を順守いたします。
              </Typography>
              <ul>
                <li>DE&Iを尊重する方針、DE&I推進のための戦略及び必要なKPIを含む計画の策定</li>
                <li>リーダーシップによるDE&I体現とコミュニケーション</li>
                <li>心理的安全性と包摂性のある組織風土の実現</li>
                <li>多様な人材の採用、育成</li>
                <li>透明性の確保</li>
                <li>無意識の偏見へのシステミックな対応</li>
                <li>DE&Iに関わる教育、研修</li>
                <li>定期的な評価とフィードバック</li>
              </ul>
            </>
          </Box>

          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              ３．ハラスメントの根絶に向けて
            </Typography>
            <>
              <Typography variant="body1">
                ハラスメントは人権にかかわる問題であり、当社は当社内及び当社の投資先・投資検討先の役職員の皆様に対するハラスメント行為を断じて許しません。
                当社は、ハラスメント行為の根絶に向けて以下の取り組みを実行いたします。
              </Typography>
              <ul>
                <li>ハラスメントやあらゆる形態の差別を許容しない方針の策定</li>
                <li>経営層によるハラスメント根絶に向けた姿勢の明示</li>
                <li>安全な通報・報告システムの構築と公正な運用</li>
                <li>ハラスメントや差別の根絶に向けた教育、研修</li>
              </ul>
            </>
          </Box>

          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              ４．相談窓口
            </Typography>
            <Typography variant="body1">
              本ポリシーに関して、我々についての法令等に違反する行為等について通報することができる相談窓口を設置しています。
              <br />
              大江橋法律事務所　AGキャピタルハラスメント相談窓口係
              <br />
              E-mail：agcp_helpline@ohebashi.com
              <br />
              郵便：〒100-0005　東京都千代田区丸の内2-2-1　岸本ビル2階
            </Typography>
          </Box>
        </article>
      </Box>
    </>
  )
}

export default DEIPolicy
